import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedContact: {},
  chatList: [],
  selected: 0,
  lastReceivedMessage: null,
  chatDeleted: false,
};

export const contactSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    handleContactData: (state, payload) => {
      state.selectedContact = payload.payload;
      state.chatDeleted = false;
    },
    handleChat: (state, payload) => {
      const newMessage = payload.payload;
      const existingIndex = state.chatList.data.findIndex(msg =>
        (msg.id && msg.id === newMessage.id) ||
        (newMessage.client_id && msg.id === newMessage.client_id)
      );

      if (existingIndex !== -1) {
        // Update existing message (e.g. status, real ID)
        state.chatList.data[existingIndex] = { ...state.chatList.data[existingIndex], ...newMessage };
      } else {
        state.chatList.data.push(newMessage);
      }

      // If we receive ANY new message, the 24h window is open
      state.chatList.isclosed = false;
    },
    changeChat: (state, payload) => {
      state.chatList = payload.payload;
    },
    changeSelection: (state, payload) => {
      state.selected = payload.payload;
    },
    setLastReceivedMessage: (state, payload) => {
      state.lastReceivedMessage = payload.payload;
      const msg = payload.payload;
      const current = state.selectedContact;
      // Check if message is from the currently selected contact
      if (current && (current.wa_number === msg.from || current.num === msg.from)) {
        // Update name if provided
        if (msg.contact_name) {
          // We create a new object to trigger re-renders
          state.selectedContact = {
            ...current,
            name: msg.contact_name,
            contact_name: msg.contact_name // Ensure both fields are updated just in case
          };
        }
      }
    },
    prependMessages: (state, payload) => {
      state.chatList.data = [...payload.payload, ...state.chatList.data];
    },
    updateSelectedContact: (state, action) => {
      state.selectedContact = { ...state.selectedContact, ...action.payload };
    },
    setChatDeleted: (state, action) => {
      state.chatDeleted = action.payload;
    },
    updateChatWindowStatus: (state, action) => {
      state.chatList.isclosed = action.payload;
    },
  },
});

export const { handleContactData, handleChat, changeChat, changeSelection, setLastReceivedMessage, prependMessages, updateSelectedContact, setChatDeleted, updateChatWindowStatus } =
  contactSlice.actions;

export default contactSlice.reducer;
